import $ajax from 'axios'
// import {Message} from 'element-ui'
import {hideLoad} from '@/tools/loading.js'
import msgWarning from '@/tools/msgwarning.js'
import api from '@/utils/api.js'

/*
  得到商品信息 get /sku/GetSkuNames
  keyword       str 查询关键字
  nameIDs       str SkuName IDs列表
  skuIDs        str Sku ID列表
  id            int SkuName ID
  name          str 商品名称
  prefix        str 商品前缀
  placeCode     int 可售地点Code
  isGlobal      boo 是否全国可售
  categoryID    int 商品所属类别ID
  skuCategoryID int sku分类
  unit          str 商品单位
  vendorSkuIDs  str 商品平台ID
  fromStatus    int 查询起始状态（0正常 1下架）
  toStatus      int 查询结束状态（0正常 1下架）
  offset        int 起始序号
  pageSize      int 列表页大小 -1表示全部
  nameIDs
  skuIDs
*/

function getSkuNames (json, fn) {
  $ajax.get('v2/sku/GetSkuNames', {
    params: json
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}
function getSkuNamesNew (json, fn) {
  $ajax.get('v2/sku/GetSkuNamesNew', {
    params: json
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}
/*
  删除整个商品 skuName delete /sku/DeleteSkuName
  nameID  int 商品名ID
*/

function deleteSkuName (nameID, fn) {
  $ajax.delete('v2/sku/DeleteSkuName', {
    params: {
      nameID
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}
export async function deleteSkuName2 (nameID, fn, noSyncAlert) {
  try {
    let res = await api('v2/sku/DeleteSkuName', {
      method: 'DELETE',
      params: {
        nameID
      },
      noSyncAlert
    })
    if (res.code && res.code === '-105') {
      fn && fn(res)
    } else {
      fn && fn({code: '0'})
    }
  } catch (e) {
    fn && fn(e)
  }
}

/*
  删除商品规格sku delete /sku/DeleteSku
  skuID   int 商品ID
*/
async function deleteSku (skuID, fn) {
  try {
    let res = await api('v2/sku/DeleteSku', {
      method: 'DELETE',
      params: {
        skuID
      }
    })
    if (res.code && res.code === '-105') {
      fn && fn(res)
    } else {
      fn && fn({code: '0'})
    }
  } catch (e) {
    fn && fn(e)
  }
}

/*
  修改SkuName put /sku/UpdateSkuName
  nameID    int 商品名ID
  payload   str json  skus, places无效
*/
async function updateSkuName (nameID, json, fn, extraJson) {
  try {
    let data = `nameID=${nameID}&payload=${encodeURIComponent(JSON.stringify(json))}`
    if (extraJson && ('isExd' in extraJson)) {
      data += `&isExd=true`
    }
    let res = await api('v2/sku/UpdateSkuName', {
      method: 'PUT',
      data
    })
    if (res.code && res.code === '-105') {
      fn && fn(res)
    } else {
      fn && fn({code: '0'})
    }
  } catch (e) {
    fn && fn(e)
  }
}

/*
  得到厂商商品类别 get /sku/GetVendorCategories
  vendorID int 厂商ID
  parentID int -1表示所有，缺省为-1
*/

/*
  增加商品 post /sku/AddSkuName
  payload json
*/
function AddSkuName (json, fn) {
  let formData = new FormData()
  formData.append('payload', JSON.stringify(json))
  $ajax.post('v2/sku/AddSkuName', formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => {
    hideLoad()
    fn && fn(res.data)
  }).catch(err => {
    hideLoad()
  })
}

/*
  更新sku put /sku/UpdateSku
  skuID int 商品名id
  payload json
*/
async function updateSku (skuID, json, fn) {
  try {
    let res = await api('v2/sku/UpdateSku', {
      method: 'PUT',
      data: `skuID=${skuID}&payload=${encodeURIComponent(JSON.stringify(json))}`
    })
    if (res.code && res.code === '-105') {
      fn && fn(res)
    } else {
      fn && fn({code: '0'})
    }
  } catch (e) {
    fn && fn(e)
  }
}

/*
  添加sku post /sku/AddSku
  nameID int skuName ID
  payload json
*/
async function AddSku (nameID, json, fn) {
  try {
    let res = await api('v2/sku/AddSku', {
      method: 'POST',
      data: `nameID=${nameID}&payload=${encodeURIComponent(JSON.stringify(json))}`
    })
    if (res.code && res.code === '-105') {
      fn && fn(res)
    } else {
      fn && fn({code: '0', data: res})
    }
  } catch (e) {
    fn && fn(e)
  }
}

/**
 * 获取分类信息
 */
async function getCate(params,noLoading =true) {
  try {
    let res = await api('v2/sku/GetVendorCategories', {
      params,
      noLoading
    })
    return res
  } catch (error) {
    console.log('error',error)
  }
}

/*
  添加sku post /sku/AddSku
  nameID int skuName ID
  payload json
*/
function transformJdSpu2SkuApi (nameIDs, fn) {
  let formData = new FormData()
  formData.append('nameIDs', nameIDs)
  $ajax.post('v2/initdata/TransformJdSpu2Sku', formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => {
    hideLoad()
    fn && fn(res.data)
  }).catch(err => {
    hideLoad()
  })
}
export {getSkuNames, getSkuNamesNew,deleteSku, deleteSkuName, updateSkuName, AddSkuName, updateSku, AddSku, transformJdSpu2SkuApi,getCate}



// WEBPACK FOOTER //
// ./src/apis/goods.js